<template>
  <div :class="$store.getters.platform === 'browser' ? 'page-bg-browser' : 'page-bg'">
    <app-loader v-if="loading"></app-loader>
    <div v-else>
      <div :id="'cont-' + content.id" class="wrapper-data page-bg-browser" v-bg="{image: content.background, alternative: true}">
        <video-bg v-if="content.trailer" ref="videoBG" :src="content.trailer" :bg="content.background" :relative="true"></video-bg>
        <div class="logo">
          <img :src="$store.getters.getData.logo_mono">
        </div>
        <div class="content-blur"></div>
        <div class="content-title">
          <img v-if="content.title_image" :src="content.title_image"/>
          <img v-else-if="content.title_image_url" :src="content.title_image_url"/>
          <h2 v-else class="title">{{content.name}}</h2>
          <!--<img src="https://www.canalsur.es/resources/archivos_offline/2019/12/6/1575627769050Logo-transparente-800x460.png"/>-->
        </div>
        <div class="info-container">
          <p v-if="lockedAdmin" class="text-black-shadow" style="margin-bottom: .5rem; text-align:center">{{ $t("CONTENT-DETAIL.MSG-ADMIN") }}</p>

          <div class="content-title-responsive">
            <img v-if="content.title_image" :src="content.title_image"/>
            <img v-else-if="content.title_image_url" :src="content.title_image_url"/>
            <h2 v-else class="title">{{content.name}}</h2>
          </div>

          <div class="content-buttons">
            <button v-if="!locked"  v-on:click="play" v-on:keyup.enter="play" class="waves-effect waves-light btn-large btn-play focusable" tabindex="-1">
              <icon name="play"></icon>  Reproducir</button>
            <button v-else-if="!lockedAdmin"  v-on:click="checkPurchase" v-on:keyup.enter="checkPurchase" class="waves-effect waves-light btn-large focusable" tabindex="-1">{{price | currencyFormatter(currency)}}</button>

            <!--<button v-if="content.trailer" v-on:click="trailer" v-on:keyup.enter="trailer" class="waves-effect waves-light btn-large focusable" tabindex="-1" v-on:keyup.down="down">
              <icon name="play"></icon>  Ver tráiler</button>-->

            <button v-if="$store.getters.getData.is_favorite && $store.getters.user"  v-on:click="toFavorites" v-on:keyup.enter="toFavorites" class="waves-effect waves-light btn-large focusable" tabindex="-1">
                <icon v-if="waiting" name="spinner" spin class="center-icon"></icon>
                <icon v-if="!waiting && !content.is_favorite" name="regular/heart" class="center-icon"></icon>
                <icon v-if="!waiting && content.is_favorite" name="heart" class="center-icon"></icon>
                Añadir a favoritos
            </button>
          </div>

          <div class="content-details">
            <div class="content-details-sypnosis">
              <p v-if="content.description"><span>{{content.description | truncateText(500) }}</span></p>
              <p v-else><span>{{ $t("CONTENT-DETAIL.NO-DESC") }}</span></p>
            </div>
            <div class="content-details-metadata">
              <p v-if="content.duration" style="font-size: 1rem;">Duración: {{content.duration }} min</p>
            </div>
          </div>
        </div>

      </div>

      <hr v-if="content.related_contents && content.related_contents.length">

      <!-- productos relacionados -->

        <!-- contenidos relacionados -->
        <app-list v-if="content.related_contents && content.related_contents.length"
          :options="{
            id: 'related-contents-' + content.id,
            type: routeList,
            title: $i18n.t('CONTENT-DETAIL.CONTENTS'),
            items: content.related_contents,
            route: routeList,
            style: 'margin-top: 1rem;',
            wrapper: $el,
            backReplace: true
          }"
          @trailerPlay="pauseTrailer"
          @trailerStop="playTrailer"
        />

        <Modal v-if="showModal" @close="closeModal">
          <!-- modal dialog -->
          <p slot="body">{{ textDialog }}</p>

          <a slot="footer" @click="closeModal" class="waves-effect waves-light btn-large modal-focusable" style="    margin-right: .5rem;">{{ $t("GENERAL.CANCEL") }}</a>

          <a v-if="showModal === 'login'" slot="footer" @click="goLogin" class="waves-effect waves-light btn-large modal-focusable">Login</a>
          <a v-if="showModal === 'suscription'" slot="footer" @click="goUpdate" class="waves-effect waves-light btn-large modal-focusable">{{ $t("GENERAL.ACCEPT") }}</a>

        </Modal>

    </div>
  </div>
</template>

<script>
import Bus from '@/components/ControlBus'
import Loader from '@/components/Loader'
import List from '@/components/List'
import {StatsContentDetail, enviroment} from '@/utils/constants'
import VideoBg from '@/components/video-bg'
import Modal from '@/components/Modal'
import { setLocation, getLocation } from '@/utils/helper-functions'
const contentsService = require('@/services/contents.js')

export default {
  name: 'ContentDetail',
  components: {
    'app-loader': Loader,
    'app-list': List,
    'video-bg': VideoBg,
    Modal
  },
  data () {
    return {
      content: {},
      showModal: false,
      keys: [
        {text: this.$i18n.t('KEYS.BACK'), action: this.$i18n.t('KEYS.RETURN')},
        {text: this.$i18n.t('KEYS.OK'), action: this.$i18n.t('KEYS.SELECT')},
        {color: 'yellow', action: this.$i18n.t('KEYS.HOME')}
      ],
      waiting: false
    }
  },
  created: function () {
    const fromStore = parseInt(this.$route.params.id) === this.$store.getters.contentStackTop.id
    if (fromStore) {
      // content store
      let content = this.$store.getters.contentStackTop
      content.trailer = false
      this.content = content
      window.Countly.q.push(['track_pageview', StatsContentDetail + ' ' + this.content.id + ': ' + this.content.name])
    }
    // content server
    this.getGeolocation(fromStore)
  },
  mounted: function () {
    // control keys
    Bus.$on('key-back', this.keyBack)
    Bus.$on('key-yellow', this.keyYellow)
  },
  methods: {
    getGeolocation (fromStore) {
      let location = getLocation(this.$store.getters.getData.is_zones)
      if (location) {
        this.getContent(fromStore, location.lat, location.lon)
      } else {
        if (navigator.geolocation && !window.webOS) {
          // obtenemos geolocalización (LG no lo permite)
          let options = {
            enableHighAccuracy: false,
            timeout: 8000,
            maximumAge: Infinity
          }
          navigator.geolocation.getCurrentPosition(
            (position) => {
              setLocation({lat: position.coords.latitude, lon: position.coords.longitude})
              this.getContent(fromStore, position.coords.latitude, position.coords.longitude)
            },
            () => { this.getContent(fromStore, 0, 0) },
            options)
        } else {
          this.getContent(fromStore, 0, 0)
        }
      }
    },
    getContent (fromStore, lat, lon) {
      contentsService.getContent(this.$route.params.id, lat, lon).then(response => {
        this.content = response.data

        // metas
        // document.title = this.content.name
        // document.querySelector('meta[name="Description"]').setAttribute('content', this.content.description.slice(0, 100))

        window.Countly.q.push(['track_pageview', StatsContentDetail + ' ' + this.content.id + ': ' + this.content.name])
      })
    },
    trailer () { this.$router.push({name: 'content-trailer', params: { id: this.content.id }}) },
    play () {
      if (!this.content.content_resources.length && !this.$store.getters.user) {
        this.textDialog = this.$i18n.t('GENERAL.REQUIERE-LINK')
        this.showModal = 'login'
      } else if (!this.content.content_resources.length && this.$store.getters.user) {
        this.textDialog = this.$i18n.t('CONTENT-DETAIL.MSG-SUS')
        this.showModal = 'suscription'
      } else {
        if (this.$router.currentRoute.name === 'search-content-detail') {
          // from search
          this.$router.push({name: 'search-content-view', params: { id: this.content.id }})
        } else {
          // from contents
          this.$router.push({name: 'content-view', params: { id: this.content.id }})
        }
      }
    },
    playTrailer () { if (this.$refs.videoBG) this.$refs.videoBG.play() },
    pauseTrailer () { if (this.$refs.videoBG) this.$refs.videoBG.pause() },
    checkPurchase () {
      if (!this.$store.getters.user) {
        this.textDialog = this.$i18n.t('GENERAL.REQUIERE-LINK')
        this.showModal = 'dialog'
      } else {
        this.purchase()
      }
    },
    purchase () {
      this.$store.commit('setPurchase', {
        type: 'cnt',
        id: this.content.id,
        'inna': this.content.inapppurchase.id,
        'price': this.content.inapppurchase.price
      })
      if (this.$router.currentRoute.name === 'search-content-detail') {
        // from search
        this.$router.push({name: 'search-purchase-summary-content'})
      } else {
        // from contents
        this.$router.push({name: 'purchase-summary-content'})
      }
    },
    keyBack: function () {
      if (!document.getElementById('app-modal')) {
        this.$store.commit('contentStackPop')
        // retrocedemos a home
        // this.$router.replace({name: 'content'})
        this.$router.replace({name: 'content'})
      }
    },
    keyYellow: function () { },
    closeModal: function () { this.showModal = false },
    goLogin: function () { this.$router.push({name: 'login-browser'}) },
    goUpdate: function () {
      let env = enviroment
      if (enviroment === 'api' || enviroment === 'api-pinko') { env = 'portal' }
      window.location.href = 'https://' + env + '.interactvty.com/tv/' + this.$store.getters.getData.name + '/?rt=' + this.$store.getters.getRefreshToken
    },
    toFavorites: function () {
      if (!this.waiting) {
        this.waiting = true
        if (!this.content.is_favorite) {
          contentsService.addFavorites({content: this.content.id}).then(response => {
            this.content.is_favorite = response.data.id
            this.waiting = false
            Bus.$emit('update-list', { item: this.content, action: 'add-favorite', idFav: this.content.is_favorite })
            this.$store.getters.getData.content.is_favorite = response.data.id
          }).catch(() => {
            this.waiting = false
          })
        } else {
          contentsService.deleteFavorites(this.content.is_favorite).then(response => {
            this.content.is_favorite = 0
            this.waiting = false
            Bus.$emit('update-list', { item: this.content, action: 'remove-favorite' })
            this.$store.getters.getData.content.is_favorite = 0
          }).catch(() => {
            this.waiting = false
          })
        }
      }
    }
  },
  computed: {
    loading: function () {
      return Object.keys(this.content).length === 0
    },
    locked: function () {
      return this.content.is_premium && !this.content.is_paid
    },
    lockedAdmin: function () {
      return this.content.is_premium && !this.content.is_paid && this.content.inapppurchase.is_manual
    },
    routeList: function () {
      if (this.$router.currentRoute.name === 'search-content-detail') { return 'search-content-detail' }
      return 'content-detail'
    },
    typeList: function () {
      if (this.$router.currentRoute.name === 'search-content-detail') { return 'search-card-contents' }
      return 'card-contents'
    },
    price: function () {
      return (this.$store.getters.user && this.$store.getters.user.country2) ? this.content.inapppurchase.price * this.$store.getters.user.exchange : this.content.inapppurchase.price
    },
    currency: function () {
      return (this.$store.getters.user && this.$store.getters.user.country2) ? this.$store.getters.user.country2.currency : this.$store.getters.getData.currency
    }
  },
  beforeDestroy: function () {
    Bus.$off('key-back', this.keyBack)
    Bus.$off('key-yellow', this.keyYellow)
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="sass" scoped>

.logo
  position: absolute
  right: 0
  max-width: 16vw;
  max-height: inherit;
  padding-right: 2rem;
  margin-top: 1rem;
  min-width: 156px;

  img
    max-width: 100%;
    height: auto;
    max-height: inherit;

.wrapper-data
  position: relative;
  width: 100%;
  /*height: 56.25vw;*/
  height: 100vh
  position: relative;
  margin: auto;
  /*max-width: 1680px;*/
  overflow: hidden;
  background-color: rgb(18,18,18);

  .content-blur
    position: absolute;
    bottom: 0;
    -webkit-backdrop-filter: blur(10px);
    width: 100%;
    height: 100%;
    -webkit-mask-image: linear-gradient(to bottom,transparent 50%,#000 75%);
    background: linear-gradient(to bottom,transparent 50%,rgba(0,0,0,.2) 60%,rgba(0,0,0,.7) 100%);

  .content-title
    position: absolute;
    left: 0;
    margin: 40px 0 0 40px;
    top: 1em;
    width: 40%;

    img
      width: 100%
      height: 100%
      visibility: none
      width: calc((100vw - 80px - 20px * 3)/ 4);

    h2
      font-size: 2.4rem;
      font-weight: 700;
      margin: 0 0 .3rem 0!important;
      word-wrap: break-word;
      text-shadow: #000000 0.05em 0.05em 0.05em;

  .info-container
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    width: 100%;
    margin: 0 auto;
    max-width: 1680px;
    grid-template-columns: repeat(5,1fr);
    width: 100%;
    display: grid;
    padding: 0 40px 40px;
    grid-gap: 20px;

    .content-title-responsive
      display: none

    .content-buttons
      position: relative;
      grid-column: 1;

    .content-buttons :last-of-type
      margin-bottom: 0;

    .content-details
      position: relative;
      width: 100%;
      grid-column-start: 2;
      grid-column-end: 5;

      .content-details-sypnosis
        margin: 0;
        padding: 0;
        margin-bottom: 25px;
        font-weight: 400;
        line-height: 1.47;

        p
          margin: 0;
          padding: 0;
          font-size: 1rem;
          font-weight: 400;
          line-height: 1.47;

      .content-details-metadata p
        margin: 0;
        padding: 0;

  .btn-large
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    border-radius: 6px;
    border: none;
    padding: 0 16px;
    text-align: center;
    vertical-align: middle;
    height: 51px;
    margin-bottom: 12px;
    text-transform: inherit;
    font-size: 1rem !important;
    font-weight: 600 !important;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    line-height: 1.47;
    background-color: rgba(84,84,84,.5) !important;

    svg
      display: inline-block;
      height: 12px;
      width: 12px;
      margin-right: 6px;

  .btn-large.btn-play
    background-color: #009539 !important;

  .text
    max-width: 60%;
    min-height: 57vh;
    min-width: 300px;
    clear: both;
    color: white;
    padding: 1rem;
    margin-left: 2rem;

    h2
      font-size: 2.3rem;
      font-weight: 500;
      margin: 0 0 .3rem 0!important;
      word-wrap: break-word;

    p
      font-size: 1.4rem;
      line-height: 1.4;
      margin: 0 0 .3rem 0;

  .locked
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100vw;
    height: 30vh;
    text-align: center;

hr
  height: .2rem!important;
  display: block;
  padding: 0;
  margin: 1em 0 0 0;
  height: 0;
  border: 0;
  background-color: rgba(84,84,84,.5) !important

.center-icon
  font-size: 3rem
  display: inline-flex;
  vertical-align: middle;

// MOBILE VERSION (800px and down)
@media (max-width: 800px)
  .wrapper-data
    height: 90vh

    .content-title
      visibility: hidden

    .info-container
      position: absolute
      bottom: 0
      left: 0
      right: 0
      width: 100%
      margin: 0 auto
      max-width: 1680px
      width: 100%
      display: grid
      padding: 0 20px
      grid-gap: 20px
      grid-template-columns: 1fr

      .content-title-responsive
        display: flex;
        align-items: center;
        justify-content: center;
        flex-direction: column;

        img
          max-width: 80%
          width: 100%
          height: 100%

      .content-buttons
        position: relative
        grid-column: 1

        .btn-large
          height: 35px

      .content-details
        grid-column-start: auto
        grid-column-end: auto

        p
          font-size: 0.8rem

</style>



// WEBPACK FOOTER //
// src/templates/canal-sur/contents/content-detail.vue